import React from 'react';
import { APP_PATHS } from '../../utils/appPaths.js';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/images/logo/logo-icon.png"
//? to replace with some padding and margin
const SidebarIcon = () => {
  // const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper">
      <Link to={APP_PATHS.dashboard}>
        <img
          className="img-fluid"
          src={cubaimg}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;